export default "__VITE_ASSET__C$hsmgXA__"